// @ts-nocheck
import { formatMessageDate } from '@/lib/chat-utils';

interface ChatDateSeparatorProps {
  date: Date | string;
}

export function ChatDateSeparator({ date }: ChatDateSeparatorProps) {
  return (
    <div className="flex items-center gap-3 my-2" data-testid="chat-date-separator">
      <div className="flex-1 h-px bg-border" />
      <span className="text-[11px] text-muted-foreground font-medium shrink-0">
        {formatMessageDate(date)}
      </span>
      <div className="flex-1 h-px bg-border" />
    </div>
  );
}
